// extracted by css-extract-rspack-plugin
export default {"icon":"use-position-table-actions_icon__ptFQ8"};